import React, { Children } from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: ReactNode;
  className?: string;
  alternate?: boolean;
  id?: string;
}
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1
    }
  }
};
export const childVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
};
export function SectionWrapper({
  children,
  className = '',
  alternate = false,
  id
}: SectionWrapperProps) {
  return <motion.section id={id} className={`
        w-full py-10 md:py-28 px-6
        ${alternate ? 'bg-deep-alt' : 'bg-deep'}
        ${className}
      `} variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
    once: true,
    margin: '-80px'
  }} data-id="element-433">
      <div className="max-w-2xl mx-auto" data-id="element-434">{children}</div>
    </motion.section>;
}